import React, { useRef, useState, useEffect } from 'react';
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';
import { Tag } from 'primereact/tag';
import { Dialog } from 'primereact/dialog';
import { ProgressBar } from 'primereact/progressbar';
import { Dropdown } from 'primereact/dropdown';
import * as moment from 'moment';

import * as _ from 'lodash';
import { v4 as uuidv4, v4 } from 'uuid';

import { ViewService } from '../../../service/ViewService';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';

export const RecordSplitter = (props) => {

    const toast = useRef(null);

    const [conciliationRecords, setConciliationRecords] = useState([].concat(props.records));
    const [forcedTotal] = useState(parseFloat([].concat(props.records).reduce((accumulator, record) => accumulator + parseFloat(record.value), 0)));
    const [currentTotal, setCurrentTotal] = useState(parseFloat([].concat(props.records).reduce((accumulator, record) => accumulator + parseFloat(record.value), 0)));
    
    const add = () => {
        const template = Object.assign({}, conciliationRecords[0]);
        template.id = uuidv4();
        template.value = 0;
        setConciliationRecords(conciliationRecords.concat([template]));
    }

    const updateItem = (itemId, field, value) => {
        let _conciliationRecords = [].concat(conciliationRecords);
        _.set(_conciliationRecords.find(i => i.id === itemId), field, value);
        console.log(_conciliationRecords.map(c => c.value))
        setConciliationRecords(_conciliationRecords);
        setCurrentTotal(_conciliationRecords.filter(i => !i.deleted).reduce((accumulator, record) => accumulator + parseFloat(record.value), 0));
    }

    const remove = (itemId) => {
        let _conciliationRecords = [].concat(conciliationRecords);
        _.set(_conciliationRecords.find(i => i.id === itemId), "deleted", true);
        setConciliationRecords(_conciliationRecords);
        setCurrentTotal(_conciliationRecords.filter(i => !i.deleted).reduce((accumulator, record) => accumulator + parseFloat(record.value), 0));
    }

    const dialogFooter = (
        <>
            <Button disabled={false} label={"Adicionar"} icon="pi pi-plus" tooltip="Criar novo item" tooltipOptions={{position: 'bottom'}} className="p-button-success p-mr-2" onClick={() => add()} />
            <Button disabled={currentTotal !== forcedTotal} label={"Aplicar"} tooltip={currentTotal !== forcedTotal ? "A soma dos itens deve ser igual ao total original" : "Aplicar divisão"} tooltipOptions={{position: 'bottom'}} icon="pi pi-check" className="p-button-success p-mr-2" onClick={() => props.onUpdate(conciliationRecords)} />
            <Button disabled={false} label={"Cancelar"} icon="pi pi-times" className="p-button-secondary p-mr-2" onClick={props.onClose} />
        </>
    );

    const formatCurrency = (value) => {
		return parseFloat(value).toLocaleString('pt-BR',{minimumFractionDigits: 2, style: 'currency', currency: 'BRL'});
    };

    

    return (
        <>
        <Toast ref={toast}></Toast>
        <Dialog visible={true} onHide={props.onClose} style={{ width: '50vw' }} header="Dividir Lançamento"
            footer={dialogFooter}
            modal>            
            <DataTable 
                    value={conciliationRecords.filter(i => !i.deleted)}
                    dataKey="id"
                    style={{width: '100%'}}
                    >
                        <Column field="date" header="Data" style={{textAlign: 'center', width: '100px'}} body={(data) => moment(props.financialRecords.find(fr => fr.id === data.financial_record_id).date).utc().format("DD/MM/YYYY")}></Column>
                        <Column field="description" header="Descrição" body={(data) => props.financialRecords.find(fr => fr.id === data.financial_record_id).description}></Column>
                        <Column 
                            field="value" 
                            header="Valor" 
                            style={{width: '120px'}} 
                            footer={
                                <>
                                    <span style={{textAlign: 'right', width: '120px', fontWeight: 'normal', color: currentTotal === forcedTotal ? '#000' : 'red' }}>{formatCurrency(currentTotal)}</span><br/>
                                    <span style={{textAlign: 'right', width: '120px', borderTop: '1px solid #000' }}>{formatCurrency(forcedTotal)}</span>
                                </>
                            }
                            footerStyle={{textAlign: 'right', width: '120px'}}
                            body={(data) => 
                            <InputNumber value={data.value} onValueChange={(e) => updateItem(data.id, "value", parseFloat(e.value).toFixed(2))} mode="decimal" locale="de-DE" minFractionDigits={2} maxFractionDigits={2} prefix="R$" inputStyle={{textAlign: 'right', width: '120px'}}  />
                        }></Column>
                        <Column field="id" header=""  style={{textAlign: 'right',width:'100px'}} body={(data) => 
                            <Button disabled={conciliationRecords.filter(i => !i.deleted).length <= 1} icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={() => remove(data.id)} />
                        }/>
                </DataTable>
        </Dialog>
        </>
    )
}